import React, { useRef, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import AlertModal from "./AlertModal";
import "./ContactForm.css";
import "./AlertModal.css";

const ContactForm = () => {
  const captchaRef = useRef(null);
  const [alertMessage, setAlertMessage] = useState("");

  const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [showAlert, setShowAlert] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!window.grecaptcha) {
      setAlertMessage("ReCAPTCHA nie jest dostępna. Spróbuj ponownie później.");
      setShowAlert(true);
      return;
    }

    try {
      const token = await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(SITE_KEY, { action: "submit" })
            .then(resolve)
            .catch(reject);
        });
      });

      const response = await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          token: token,
        }),
      });

      if (response.ok) {
        setAlertMessage("Formularz został wysłany pomyślnie!");
        setFormData({ name: "", email: "", message: "" });
        // captchaRef.current.reset();
        setShowAlert(true);
      } else {
        setAlertMessage("Wysyłka nie powiodła się. Spróbuj ponownie.");
        setShowAlert(true);
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania:", error);
      setAlertMessage("Wystąpił błąd sieci.");
      setShowAlert(true);
    }
  };
  // Resetowanie formularza
  const handleReset = () => {
    setFormData({
      name: "",
      email: "",
      message: "",
    });
    captchaRef.current.reset();
  };
  return (
    <Container className="contact-form">
      <Row>
        <Col className="text-center">
          <h1 className="contact-form-h1-mini">Formularz kontaktowy</h1>
          <h1 className="contact-form-h1">Formularz kontaktowy</h1>
        </Col>
      </Row>
      {showAlert && (
        <AlertModal
          message={alertMessage}
          onClose={() => setShowAlert(false)}
        />
      )}
      <Row className="justify-content-center">
        <Col xs={12} md={6}>
          <Form
            className="contact-form-form"
            onSubmit={handleSubmit}
            onReset={handleReset}
          >
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Imię i nazwisko:</Form.Label>
              <Form.Control
                type="text"
                placeholder="Wpisz swoje imię i nazwisko"
                name="name"
                onChange={(e) => {
                  setFormData({ ...formData, name: e.target.value });
                }}
                value={formData.name}
                required
                minLength={3}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email:</Form.Label>
              <Form.Control
                type="email"
                placeholder="Wpisz swój email"
                name="email"
                onChange={(e) => {
                  setFormData({ ...formData, email: e.target.value });
                }}
                value={formData.email}
                required
                minLength={3}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicMessage">
              <Form.Label>Wiadomość:</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Wpisz swoją wiadomość"
                name="message"
                onChange={(e) => {
                  setFormData({ ...formData, message: e.target.value });
                }}
                value={formData.message}
                required
                minLength={3}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicCaptcha">
              {/* <ReCAPTCHA
                ref={captchaRef}
                sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                onChange={(value) => console.log("Captcha token:", value)}
              /> */}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicSubmit">
              <button type="submit" className="btn btn-success">
                Wyślij wiadomość
              </button>
              &nbsp;
              <button type="reset" className="btn btn-secondary">
                Wyczyść formularz
              </button>
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactForm;
